import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { moduleNamespace } from '@Store/config.store';
import { NamespacedStoreState } from '@Types/store.types';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

const rehabStoreSelector = createSelector(parseNamespace, state => state.RehabStore);

export const eventTypesSelector = createSelector(rehabStoreSelector, store => store.eventTypes ?? []);
export const taskTypesSelector = createSelector(rehabStoreSelector, store => store.taskTypes ?? []);
export const conditionScoreTypesSelector = createSelector(rehabStoreSelector, store => store.conditionScores ?? []);
export const rehabMetadataLoadingSelector = createSelector(rehabStoreSelector, store => store.isLoading);

export const selectEventTypes = () => useSelector(eventTypesSelector);

export const selectTaskTypes = () => useSelector(taskTypesSelector);

export const selectConditionScoreTypes = () => useSelector(conditionScoreTypesSelector);

export const selectRehabMetadataLoading = () => useSelector(rehabMetadataLoadingSelector);
